export default (sentence, limit)  => {
  var
    ellipsis = '...',
    l = sentence.length

  if (l < limit)
    return sentence

  for (var i = -4; i < 4; i++) {
    if (sentence.substr(limit - i, 1) === ' ') {
      return sentence.substr(0, limit - i) + ellipsis
    }
  }

  return sentence.substr(0, limit) + ellipsis
}
